import { render } from "./Choujiang.vue?vue&type=template&id=48c85f8a&scoped=true&ts=true"
import script from "./Choujiang.vue?vue&type=script&lang=ts"
export * from "./Choujiang.vue?vue&type=script&lang=ts"

import "./Choujiang.vue?vue&type=style&index=0&id=48c85f8a&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c85f8a"]])

export default __exports__